module.exports = __webpack_public_path__ + "img/img4.3d9e7765.png";